import { px2rem } from '@elixir/styling';
export function getButtonStyles(theme) {
    return {
        root: {
            height: px2rem(35),
        },
        icon: {
            color: theme.palette.neutralPrimary,
        },
        iconHovered: {
            color: theme.palette.neutralPrimary,
        },
        iconPressed: {
            color: theme.palette.black,
        },
    };
}
export const commandBarStyles = {
    root: {
        padding: 'unset',
        background: 'transparent',
    },
};
